import React from "react";
import MaterialTable from "material-table";
import { convertDateToString } from "../../../Functions/dateFormats";

const CampusAmbassadorTableData = (props) => {
  const columns = [
    {
      field: "referralCode",
      title: "Referral Code",
      export: true,
    },
    {
      field: "startTime",
      title: "Start Time",
      export: true,
      // render: rowData => convertDateToString(rowData.startTime)
    },
    {
      field: "endTime",
      title: "End Time",
      export: true,
      // render: rowData => convertDateToString(rowData.endTime)
    },
    {
      field: "count",
      title: "Count",
      export: true,
      render: (rowData) => (
        <div className="download-tracking-count flex flex-justify-center">
          {rowData.count}
        </div>
      ),
    },
    {
      field: "name",
      title: "Name",
      export: true,
    },
    {
      field: "email",
      title: "Email",
      export: true,
    },
    {
      field: "phone",
      title: "Mobile Number",
      export: true,
    },
    {
      field: "userId",
      title: "User ID",
      export: true,
    },
  ];

  return (
    <div className="table">
      <MaterialTable
        title={`Campus Ambassador Data`}
        columns={columns}
        data={props?.data}
        options={{
          headerStyle: {
            backgroundColor: "#245642",
            color: "#FFF",
          },

          search: true,
          exportButton: true,
          sorting: true,
          paginationType: "stepped",
        }}
      />
    </div>
  );
};

export default CampusAmbassadorTableData;
